import {
  FormControl,
  Input,
  Select,
  Text,
} from '@chakra-ui/react';
import React, { ReactChild } from 'react';
import {
  Field,
} from 'react-final-form';
import Label from '../../../components/Intake/Label';

const SelectField = (
  { name, label, validate, optional, children, ...rest }: {
    name: string,
    label?: ReactChild,
    optional?: boolean,
    children?: React.ReactNode,
    validate?: (value: any) => string | undefined,
  },
) => {
  return (
    <Field name={name} validate={validate}>
      {({ input, meta }) => (
        <FormControl>
          <Label optional={optional}>{label}</Label>
          <Select
            {...input}
            {...rest}
            isInvalid={meta.touched && meta.error}
            errorBorderColor="red.300"
          >
            {children}
          </Select>
          {meta.touched && meta.error && (
            <Text color="red.300" fontSize="sm" mt={2} px={4}>{meta.error}</Text>
          )}
        </FormControl>
      )}
    </Field>
  );
};

export default SelectField;
